import { createSlice, createAsyncThunk, createSelector } from '@reduxjs/toolkit';
import { GetJson } from '../helpers/fetchReact';
import { REST_API } from '../constants';
import { STATE_STATUS } from '../constants';
import { isValueEmpty } from '@awp/helpers/utilsReact';

const initialState = {
  modelstatuses: [],
  modelstatus: {},
  modelstatusLoading: STATE_STATUS.IDLE,
  modelstatusError: null,

  types: [],
  type: {},
  typeLoading: STATE_STATUS.IDLE,
  typeError: null,

  manufacturers: [],
  manufacturer: {},
  manufacturerLoading: STATE_STATUS.IDLE,
  manufacturerError: null,
};

export const selectAllModelstatuses = (state) => state.sensorModel.modelstatuses;
export const selectModelstatusId = (state) => state.sensorModel.modelstatus.Id;
export const selectAllTypes = (state) => state.sensorModel.types;
export const selectTypeId = (state) => state.sensorModel.type.Id;
export const selectAllManufacturers = (state) => state.sensorModel.manufacturers;
export const selectManufacturerId = (state) => state.sensorModel.manufacturer.Id;

export const getModelstatusLoading = (state) => state.sensorModel.modelstatusLoading;
export const getTypeLoading = (state) => state.sensorModel.typeLoading;
export const getManufacturerLoading = (state) => state.sensorModel.manufacturerLoading;

// Selector to find a single Id by sensorName
export const selectSensorIdByName = (sensorName) =>
  createSelector([selectAllTypes], (types) => {
    const matchingSensor = types.find((sensor) => sensor.Name === sensorName);
    return matchingSensor ? matchingSensor.Id : null; // Return Id or null if not found
  });

export const fetchModelstatuses = createAsyncThunk(
  'sensorModel/fetchModelstatuses',
  async () => {
    const url = REST_API.SENSOR_MODEL + 'statuses';

    return GetJson(url).then((response) => response.json());
  },
  {
    condition: (args, { getState }) => {
      const { sensorModel: state } = getState();
      return state.modelstatusLoading !== STATE_STATUS.LOADING;
    },
  },
);
export const fetchTypes = createAsyncThunk(
  'sensorModel/fetchTypes',
  async () => {
    const url = REST_API.SENSOR_MODEL + 'types';

    return GetJson(url).then((response) => response.json());
  },
  {
    condition: (args, { getState }) => {
      const { sensorModel: state } = getState();
      return state.typeLoading !== STATE_STATUS.LOADING;
    },
  },
);
export const fetchManufacturers = createAsyncThunk(
  'sensorModel/fetchManufacturers',
  async () => {
    const url = REST_API.SENSOR_MODEL + 'manufacturers';

    return GetJson(url).then((response) => response.json());
  },
  {
    condition: (args, { getState }) => {
      const { sensorModel: state } = getState();
      return state.manufacturerLoading !== STATE_STATUS.LOADING;
    },
  },
);

export const sensorModelSlice = createSlice({
  name: 'sensorModel',
  initialState,
  reducers: {
    setModelstatus(state, action) {
      state.modelstatus = action.payload;
    },
    setType(state, action) {
      state.type = action.payload;
    },
    setManufacturer(state, action) {
      state.manufacturer = action.payload;
    },
  },
  extraReducers: {
    [fetchModelstatuses.pending]: (state) => {
      state.modelstatusLoading = STATE_STATUS.LOADING;
    },
    [fetchModelstatuses.fulfilled]: (state, action) => {
      state.modelstatusLoading = STATE_STATUS.SUCCESS;

      state.modelstatuses = action.payload;
      if (isValueEmpty(state.modelstatus) || state.modelstatus.Id < 1) {
        let defaultStatus = state.modelstatuses.find((s) => (s.Name + '').toLowerCase() == 'active');
        state.modelstatus = { ...defaultStatus };
      }
    },
    [fetchModelstatuses.rejected]: (state, action) => {
      state.modelstatusLoading = STATE_STATUS.FAILED;
      state.modelstatusError = action.error.message;
    },

    [fetchTypes.pending]: (state) => {
      state.typeLoading = STATE_STATUS.LOADING;
    },
    [fetchTypes.fulfilled]: (state, action) => {
      state.typeLoading = STATE_STATUS.SUCCESS;
      let _types = action.payload;
      let nullableTypes = [];
      nullableTypes.push({ Description: '', DropdownText: '		', Id: 0, Name: ' ' });
      _types.map((t) => {
        nullableTypes.push(t);
      });
      state.types = nullableTypes;
    },
    [fetchTypes.rejected]: (state, action) => {
      state.typeLoading = STATE_STATUS.FAILED;
      state.typeError = action.error.message;
    },

    [fetchManufacturers.pending]: (state) => {
      state.manufacturerLoading = STATE_STATUS.LOADING;
    },
    [fetchManufacturers.fulfilled]: (state, action) => {
      state.manufacturerLoading = STATE_STATUS.SUCCESS;
      let _manufacturers = action.payload;

      let nullableManufacturers = [];
      _manufacturers.map((t) => {
        nullableManufacturers.push(t);
      });
      state.manufacturers = nullableManufacturers;
    },
    [fetchManufacturers.rejected]: (state, action) => {
      state.manufacturerLoading = STATE_STATUS.FAILED;
      state.manufacturerError = action.error.message;
    },
  },
});

export const { setModelstatus, setType, setManufacturer } = sensorModelSlice.actions;
